// Global constants
export const COLOR = {
  BG_LIGHTGREY: "#f6f6f6",
  BG_WHITE: "#ffffff",
  BORDER: "#e2e2e2",
};

export const FONT_SIZE = {
  LARGE: "16px",
  NORMAL: "14px",
  SMALL: "12px",
};

export const WIDTH = {
  SIDEBAR: "300px",
};

// Global style values
export const BORDER = `1px solid ${COLOR.BORDER}`;

// Functions to produce styles
export const scrollableSidebar = (height) => {
  const heightStyle = `calc(100vh - ${height}px)`;
  return {
    height: heightStyle,
    maxHeight: heightStyle,
    overflowX: "hidden",
    overflowY: "auto",
  };
};

export default {
  BORDER,
  COLOR,
  FONT_SIZE,
  scrollableSidebar,
  WIDTH,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/styles.js
 **/